import { useEffect, useState } from 'react';

import ActionButton from '@core/components/actionbutton/ActionButton';
import LanguageSelector from './LanguageSelector';

import classes from './languageSelectorWrapper.module.scss';

const LanguageSelectorWrapper = ({ data, metadata, languageChangeHandler, horizontal = true }) => {
	const [formData, setFormData] = useState(() => {
		if (!data || data.length === 0) {
			return {};
		} else {
			const initData = data.reduce((obj, item, index) => {
				// const key = item?.language?.iso || item?.language_iso || index;
				const key = index;
				obj[key] = {
					language_iso: item?.language?.iso,
					proficiency: item?.proficiency?.id,
					// formId: item?.language?.iso
					formId: index
				};
				return obj;
			}, {});
			return initData;
		}
	});
	const [formCount, setFormCount] = useState(() => {
		if (!data || data.length === 0) {
			return [0];
		} else {
			return data.map((lng) => lng?.language?.iso);
		}
	});
	const languagesChangeHandler = (newValue, index) => {
		if (newValue.language_iso) {
			setFormData((prevState) => ({				
				...prevState,
				[index]: { ...newValue, proficiency: !!newValue.proficiency ? newValue.proficiency : null },			
			}));
		}
		else{	
			setFormData({...formData,  [index]: {
				language_iso: null,
				proficiency: null,
				},
		   });
		}
	};
	useEffect(() => {
		//remove nulls before return
		var filtered = Object.values(formData).filter(function(el) { return el.language_iso != null; });		
		languageChangeHandler(Object.values(filtered));
	}, [JSON.stringify(formData)]);

	return (
		<div className={`row ${classes['language-selector-wrapper']}`}>
			<div className={`col-12 d-flex flex-column gap-3 p-0`}>
				{data && data.length > 0
					? formCount.map((lang, index) => (
							<LanguageSelector
								key={formData[index]?.formId || index}
								metadata={metadata}
								data={formData[index] || data[index]}
								index={formData[index]?.formId || index}
								languagesChangeHandler={languagesChangeHandler}
								initialIndex={index}
								horizontal={horizontal}
							/>
					  ))
					: formCount.map((lang) => (
							<LanguageSelector
								metadata={metadata}
								index={lang}
								key={lang}
								languagesChangeHandler={languagesChangeHandler}
								horizontal={horizontal}
							/>
					  ))}
				<ActionButton
					style={{ maxWidth: 'max-content' }}
					kind="blank"
					onClick={() => setFormCount((prevState) => [...prevState, prevState.length])}>
					+ Add another Language
				</ActionButton>
			</div>
		</div>
	);
};

export default LanguageSelectorWrapper;
